import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
  selectIpoFinancialInfo: "selectIpoFinancialInfo [Action]",
  selectIpoFinancialInfoLoading: "selectIpoFinancialInfoLoading [Action]",
  selectIpoFinancialInfoAsync: "selectIpoFinancialInfoAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const select_ipo_financial_info = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectIpoFinancialInfo:
      return {
        ...state,
        data: payload,
        total: payload?.total,
      };
    case actionTypes.selectIpoFinancialInfoLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectIpoFinancialInfoLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "ipo",
    method_type: "select_ipo_financial_info",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectIpoFinancialInfo,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectIpoFinancialInfoLoading,
      payload: false,
    });
  }
}

export function* selectIpoFinancialInfo() {
  yield takeLatest(actionTypes.selectIpoFinancialInfoAsync, handleWorker);
}
